import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: "#F3ECE6",
        backgroundImage:
          "radial-gradient(ellipse 120% 80% at 85% 5%, rgba(122, 20, 34, 0.07) 0%, transparent 52%), radial-gradient(ellipse 100% 70% at 5% 95%, rgba(139, 24, 40, 0.06) 0%, transparent 48%), radial-gradient(ellipse 90% 60% at 50% 50%, rgba(214, 206, 192, 0.45) 0%, transparent 55%)",
        backgroundAttachment: "fixed",
      },
    },
  },
  colors: {
    transparent: "transparent",
    // Brand palette (new)
    brand: {
      maroon: "#7A1422",
      burgundy: "#8B1828",
      wine: "#A32434",
      crimson: "#C04A58",
      cream: "#F7F2EC",
      white: "#FCFAF7",
      sand: "#F3ECE6",
      beige: "#EBE0D7",
      stone: "#D6CEC0",
      taupe: "#A8A096",
    },
    // Back-compat keys used across components
    editorial: {
      primary: "#7A1422",
      accent: "#8B1828",
      stroke: "#D6CEC0",
    },
    canvas: "#F3ECE6",
    main_font: "#A8A096",
  },

  fonts: {
    heading: "Baloo 2, cursive",
    body: "Baloo 2, cursive",
  },
});
